import styled from "styled-components";
import { textTheme, colorTheme } from "../../../../theme";

export const Container = styled.div`
  padding: 18px 28px;
`;

export const Title = styled.span`
  ${textTheme.subtitle1}
  color: ${colorTheme.black};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Text = styled.div`
  padding-top: 50px;
  padding-right: 5px;
  padding-left: 10px;
  ${textTheme.subtitle1}
  color: ${colorTheme.black};
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 27px;
  color: ${colorTheme.black};
`;

export const Name = styled.span`
  ${textTheme.body2}
`;

export const SearchContainer = styled.div`
  position: relative;
  margin-top: 20px;
  margin-bottom: 35px;
  flex-grow: 1;
`;

export const SearchIcon = styled.img`
  position: absolute;
  top: 15px;
  left: 15px;
`;

export const Searchbar = styled.input`
  ${textTheme.subtitle1}
  height: 40px;
  border: 1px solid #e2e5e6;
  border-radius: 4px;
  padding-left: 40px;
  width: 100%;
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
`;
